const pslogolist = {
  'PS_Brand': {
    url: 'https://ps-email-signature-generator.s3.amazonaws.com/PS_Logo@2x.png',
    width: 56,
    height: 74,
  },
  'PS_Pride': {
    url: 'https://ps-email-signature-generator.s3.amazonaws.com/PS_Logo_Pride_Retina.png',
    width: 51,
    height: 60,
  },
};

export default pslogolist;



// WEBPACK FOOTER //
// ./src/labels/pslogolist.js